// client/src/coms/audio/audioDevicePrefs.js

const KEY_INPUT = 'coms_audio_input_device_id';
const KEY_OUTPUT = 'coms_audio_output_device_id';
const KEY_VOICE_OUTPUT = 'coms_voice_output_device_id';

export function getPreferredInputDeviceId() {
  try {
    return localStorage.getItem(KEY_INPUT) || '';
  } catch {
    return '';
  }
}

export function getPreferredOutputDeviceId() {
  try {
    return localStorage.getItem(KEY_OUTPUT) || '';
  } catch {
    return '';
  }
}

export function getPreferredVoiceOutputDeviceId() {
  try {
    return localStorage.getItem(KEY_VOICE_OUTPUT) || '';
  } catch {
    return '';
  }
}

export function setPreferredInputDeviceId(deviceId) {
  try {
    if (deviceId) localStorage.setItem(KEY_INPUT, String(deviceId));
    else localStorage.removeItem(KEY_INPUT);
  } catch {
    return;
  }
}

export function setPreferredOutputDeviceId(deviceId) {
  try {
    if (deviceId) localStorage.setItem(KEY_OUTPUT, String(deviceId));
    else localStorage.removeItem(KEY_OUTPUT);
  } catch {
    return;
  }
}

export function setPreferredVoiceOutputDeviceId(deviceId) {
  try {
    if (deviceId) localStorage.setItem(KEY_VOICE_OUTPUT, String(deviceId));
    else localStorage.removeItem(KEY_VOICE_OUTPUT);
  } catch {
    return;
  }
}

export function emitAudioDevicePrefsChanged(payload) {
  try {
    window.dispatchEvent(new CustomEvent('coms-audio-device-changed', { detail: payload || {} }));
  } catch {
    return;
  }
}
